import React from "react";
import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa";
import SectionContainer from "./SectionContainer";
import { testimonials } from "../../data/landingData";

const TestimonialCard: React.FC<{
  testimonial: (typeof testimonials)[0];
}> = ({ testimonial }) => (
  <div className="shrink-0 w-[320px] md:w-[380px] p-6 rounded-2xl bg-space-light/60 border border-white/10 backdrop-blur-sm">
    <div className="flex items-center gap-3 mb-4">
      {testimonial.avatar ? (
        <img
          src={testimonial.avatar}
          alt={testimonial.role}
          className="w-12 h-12 rounded-full object-cover border-2 border-white/10"
        />
      ) : (
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center text-space font-bold text-lg"
          style={{ backgroundColor: testimonial.color }}
        >
          {testimonial.initials}
        </div>
      )}
      <div>
        <p className="text-body-sm font-semibold text-white">
          {testimonial.role}
        </p>
        <div className="flex gap-0.5 text-yellow-400">
          {Array.from({ length: testimonial.rating }).map((_, i) => (
            <FaStar key={i} size={12} />
          ))}
        </div>
      </div>
    </div>
    <p className="text-body-sm text-gray-300 leading-relaxed">
      「{testimonial.quote}」
    </p>
  </div>
);

const TestimonialsSection: React.FC = () => {
  const { t } = useTranslation("home");
  const doubled = [...testimonials, ...testimonials];

  return (
    <SectionContainer>
      <h2 className="text-h2 text-center mb-12 text-white">
        {t("testimonials_title")}
      </h2>

      <div className="overflow-hidden -mx-4 sm:-mx-6 lg:-mx-8">
        <div className="flex w-max marquee-track-slow gap-6 px-4">
          {doubled.map((item, index) => (
            <TestimonialCard key={`${item.id}-${index}`} testimonial={item} />
          ))}
        </div>
      </div>
    </SectionContainer>
  );
};

export default TestimonialsSection;
